<template>
    <div>
        <el-card v-if="!mobile">
            <el-form inline ref="form">
                <!-- <el-form-item label="订单号">
                    <el-input v-model="searchData.orderId" placeholder="请输入订单号查找"></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="手机号">
                    <el-input v-model="searchData.mobile" placeholder="请输入手机号查找"></el-input>
                </el-form-item>
                <el-form-item label="车牌号">
                    <el-input v-model="searchData.plate" placeholder="请输入车牌号查找"></el-input>
                </el-form-item>
                <el-form-item label="停车场类型">
                    <el-select v-model="searchData.parkType">
                        <el-option label="全部" value=""></el-option>
                        <el-option :label="item.lable" :value="item.value" v-for="(item) in $baseData.parkingType"
                            :key="item.value">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="停车场">
                    <el-select v-model="searchData.parkId" clearable filterable remote reserve-keyword
                        placeholder="请输入关键词查询停车场">
                        <el-option v-for="item in parkingAreaList" :key="item.id" :label="item.parkName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="车位号">
                    <el-input v-model="searchData.seatNum" placeholder="请输入车位号"></el-input>
                </el-form-item>
                <el-form-item label="取证超时">
                    <el-input placeholder="取证超时时间" v-model="searchData.unEvidenceTime">
                        <template slot="append">分钟以上</template>
                    </el-input>
                </el-form-item> -->
                <!-- <el-form-item label="订单类型">
                    <el-select v-model="searchData.mwOrderType">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="已取证订单" value="1"></el-option>
                        <el-option label="未取证订单" value="2"></el-option>
                        <el-option label="欠费订单" value="3"></el-option>
                        <el-option label="已支付订单" value="4"></el-option>
                        <el-option label="已完成订单" value="5"></el-option>
                        <el-option label="异常订单" value="6"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="审核类型">
                    <el-select v-model="searchData.reviewStatus">
                        <el-option label="未审核" value="0"></el-option>
                        <el-option label="已审核" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker v-model="searchData.datetimeRange" type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="$refs.table.reloadData()">搜索</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <cui-table :url="$api.queryReviewOrder" :data="searchData" ref="table" width="200" :handleData="tableHandleData">
            <el-table-column fixed prop="id" label="订单ID" width="150"></el-table-column>
            <el-table-column label="订单类型" width="100">
                <template slot-scope="scope">
                    <el-tag size="medium" v-if="Number(scope.row.orderListVO.arrearsAmount) > 0" type="danger">欠费订单</el-tag>
                    <el-tag size="medium" v-else type="success">正常订单</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="订单用户姓名" width="150">
                <template slot-scope="scope">{{ scope.row.orderListVO.userName ? scope.row.orderListVO.userName +
                    `【${scope.row.orderListVO.userMobile}】` : "临时用户" }}</template>
            </el-table-column>
            <el-table-column prop="plate" label="车牌号" width="150">
                <template slot-scope="scope">
                    <el-tag size="medium" v-if="!scope.row.orderListVO.plate" type="danger">无牌车</el-tag>
                    <p v-else>【{{ scope.row.orderListVO.plateColorRemark }}】{{ scope.row.orderListVO.plate }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="orderListVO.parkingName" label="停车场" width="180"></el-table-column>
            <el-table-column prop="orderListVO.seatNum" label="车位编号" width="100"></el-table-column>
            <el-table-column label="入场时间" min-width="160">
                <template slot-scope="scope">
                    <span>{{ scope.row.orderListVO.enterTime }}&nbsp;&nbsp;</span>
                    <el-image v-if="scope.row.orderListVO.inPic && scope.row.orderListVO.inPic.length > 0"
                        style="width: 14px; height: 14px" :src="scope.row.orderListVO.inPic"
                        :preview-src-list="[scope.row.orderListVO.inPic]"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="出场时间" min-width="160">
                <template slot-scope="scope">
                    <span>{{ scope.row.orderListVO.leaveTime }}&nbsp;&nbsp;</span>
                    <el-image v-if="scope.row.orderListVO.outPic" style="width: 14px; height: 14px"
                        :src="scope.row.orderListVO.outPic" :preview-src-list="[scope.row.orderListVO.outPic]"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="停车时长" width="130">
                <template slot-scope="scope">{{ scope.row.orderListVO | totalHours }}</template>
            </el-table-column>
            <!-- <el-table-column label="订单金额">
                <template slot-scope="scope">
                    <span v-if="scope.row.orderListVO.leaveTime">{{ scope.row.orderListVO.totalMoney }}</span>
                    <el-button v-else type="text" @click="getOrderDetail(scope.row)">{{
                        scope.row.orderListVO.totalMoney === null ? '校准' : scope.row.orderListVO.totalMoney }}</el-button>
                </template>
            </el-table-column> -->
            <el-table-column prop="orderListVO.payAmount" label="支付金额" width="100"></el-table-column>
            <el-table-column prop="orderListVO.arrearsAmount" label="欠费金额" width="100"></el-table-column>
            <el-table-column prop="orderListVO.payTime" label="支付时间" width="150"></el-table-column>
            <!-- <el-table-column prop="status" label="标记状态" width="100">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.orderListVO.status == 0" type="success">正常订单</el-tag>
                    <el-tag v-else-if="scope.row.orderListVO.status == '1'">0元放行</el-tag>
                    <el-tag v-else-if="scope.row.orderListVO.status == '2'">退款</el-tag>
                    <el-tag v-else-if="scope.row.orderListVO.status == '3'">补偿优惠券</el-tag>
                    <el-tag v-else-if="scope.row.orderListVO.status == '4'">修改进出场</el-tag>
                    <el-tag v-else-if="scope.row.orderListVO.status == '100'" type="warning">异常待处理</el-tag>
                    <el-tag v-else type="danger">状态异常</el-tag>
                </template>
            </el-table-column> -->
            <el-table-column label="操作" fixed="right" width="250">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.orderType == '1'" type="text"
                        @click="addOvertimeRemark(scope.row)">录入超时备注</el-button>
                    <el-button v-if="scope.row.orderType == '1'" type="text"
                        @click="saveOrderOutLog(scope.row.id)">手动离场</el-button>
                    <el-button v-if="scope.row.orderType == '1' && scope.row.plate" type="text"
                        @click="updateOrderToUnHaveEvidenceOrder(scope.row.id)">重新取证</el-button>
                    <!-- <el-button type="text" :disabled="['1', '2', '3', '4', '100'].indexOf(scope.row.status) > -1"
                        @click="createErrorOrder(scope.row)">
                        生成异常记录</el-button> -->
                    <!-- <el-button type="text" @click="detailList(scope.row)">支付详情</el-button> -->
                    <el-button type="text" @click="showOrderDetail(scope.row)">订单详情</el-button>
                    <!-- <cui-timeline :id="scope.row.id"></cui-timeline> -->
                    <!-- <el-button type="text" @click="selectUrgeDetail(scope.row.userId)">催收记录</el-button> -->
                </template>
            </el-table-column>
        </cui-table>

        <!-- <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="780px">
            <el-table :data='payDetailList'>
                <el-table-column prop="payId" label="第三方支付单号"></el-table-column>
                <el-table-column prop="payAmount" label="支付金额"></el-table-column>
                <el-table-column prop="couponMoney" label="优惠金额"></el-table-column>
                <el-table-column prop="payType" label="支付途径">
                    <template slot-scope="scope">
                        {{ scope.row.payType | payType }}
                    </template>
                </el-table-column>
                <el-table-column prop="payTime" label="支付时间"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog> -->

        <el-dialog :title="dialogTitle" :visible.sync="detailDialogVisible" width="1000px">
            <cui-orderdetail :order="orderDetail" :flagCount="flagCount"></cui-orderdetail>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false">关 闭</el-button>
                <el-button type="primary" @click="reviewOrder" v-if="reviewOrderData.reviewStatus == 0">审核结束</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
export default {
    name: "orderList",
    title: "平台订单",
    props: ["mobile"],
    data() {
        return {
            searchData: {
                datetimeRange: [],
                startTime: "",
                endTime: "",
                currentPage: 1,
                pageSize: 10,
                count: 0,
                reviewStatus: "0"
            },
            parkingAreaList: [],
            dialogVisible: false,
            detailDialogVisible: false,
            dialogTitle: "",
            dialogType: "",
            orderDetail: {},
            payDetailList: [],
            reviewId: "",
            reviewOrderData: {},
            tableHandleData: function (data) {
                data.map((e) => {
                    if (e.leaveTime) {
                        e.totalMoney = (e.payAmount + e.arrearsAmount).toFixed(2);
                    } else {
                        e.totalMoney = null;
                    }
                    if (e.imageArrays) {
                        let obj = JSON.parse(e.imageArrays),
                            arr = [];
                        for (const key in obj) {
                            if (obj.hasOwnProperty.call(obj, key)) {
                                arr.push(obj[key]);
                            }
                        }
                        e.inPic = arr;
                    } else if (e.inPic) {
                        e.inPic = [e.inPic];
                    } else {
                        e.inPic = [];
                    }
                });
                return data;
            },
            flagCount: 0
        };
    },
    watch: {
        mobile: function (value) {
            this.searchData.mobile = value;
            this.$refs.table.reloadData();
        },
        "searchData.datetimeRange": function (value) {
            if (value && value.length == 2) {
                this.searchData.startTime = value[0];
                this.searchData.endTime = value[1];
            } else {
                this.searchData.startTime = "";
                this.searchData.endTime = "";
            }
        },
        "searchData.parkType": function (value) {
            this.loadParkList(value);
        },
        '$route.query.reviewType'(newVal, oldVal) {
            // this.handleReviewType(newVal);
            this.searchData.reviewType = this.$route.query.reviewType;
            this.$refs.table.reloadData()
        }
    },
    created() {
        if (this.$route.query.reviewType) {
            this.searchData.reviewType = this.$route.query.reviewType;
        }
        this.mobile ? (this.searchData.mobile = this.mobile) : "";
    },
    methods: {
        showOrderDetail(item) {
            this.reviewId = item.id
            this.reviewOrderData = item
            this.detailDialogVisible = true;
            this.orderDetail = item.orderListVO
            this.dialogType = "detail";
            this.dialogTitle = `订单${item.id}的订单详情`;
            this.flagCount = this.flagCount + 1
        },
        detailList(id) {
            this.$http.get(this.$api.payDetailList, { id }, (res) => {
                this.payDetailList = res.list;
                this.dialogVisible = true;
                this.dialogType = "detail";
                this.dialogTitle = `订单${id}的支付详情`;
            });
        },
        createErrorOrder(item) {
            this.$root.$emit("showWorkorderDialog", {
                type: "order",
                data: item,
                callback: () => {
                    this.$refs.table.reloadData();
                },
            });
        },
        loadParkList(parkType) {
            this.searchData.parkId = "";
            this.$http.get(this.$api.getAllPark, { parkType }, (res) => {
                this.parkingAreaList = res.parkStatisticsForPark;
            });
        },

        addOvertimeRemark(item) {
            const { id, overtimeRemark } = item;
            this.$prompt("请输入超时未录入订单备注", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputValue: overtimeRemark,
            })
                .then(({ value }) => {
                    let path;
                    if (overtimeRemark) {
                        path = this.$api.updateOvertimeRemark;
                    } else {
                        path = this.$api.addOvertimeRemark;
                    }
                    this.$http.post(path, { orderId: id, remark: value }, (res) => {
                        this.$message.success("备注编辑成功！");
                        this.$refs.table.reloadData();
                    });
                })
                .catch(() => { });
        },
        getOrderDetail(item) {
            this.$http.post(this.$api.selectOrderDetail, { id: item.id }, (res) => {
                item.totalMoney = res.totalMoney;
            });
        },
        updateOrderToUnHaveEvidenceOrder(id) {
            this.$http.get(
                this.$api.updateOrderToUnHaveEvidenceOrder,
                { id },
                (res) => {
                    this.$message.success("状态修改成功！");
                    this.$refs.table.reloadData();
                }
            );
        },
        reviewOrder() {
            this.$confirm('是否确定将该异常订单审核完毕?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get(this.$api.reviewOrder, { id: this.reviewId }, (res) => {
                    this.$message.success("修改审核状态成功");
                    this.detailDialogVisible = false
                    this.$refs.table.reloadData();
                });
            }).catch(() => {
            });
        }
    },
};
</script>
<style scoped>
/* /deep/.el-dialog {
    margin-top: 20px;
} */

/deep/.el-dialog__body {
    padding: 10px;
}
</style>